import { restrictToVerticalAxis } from '@dnd-kit/modifiers';

// Module-level so the array identity stays stable across renders of the DndContext that consumes it.
export const verticalAxisModifier = [restrictToVerticalAxis];
